import { motion } from 'framer-motion'
import SectionHeader from './SectionHeader'
import { experience } from '../data/experience'

const Experience = () => {
  return (
    <section id="experience" className="border-y border-academic-line bg-white/45 py-20 md:py-24">
      <div className="section-shell">
        <SectionHeader
          kicker="Experience"
          title="Experience & education timeline."
          text="A concise overview of academic preparation, project development, and research-oriented technical growth."
        />

        <div className="mt-14 max-w-4xl">
          {experience.map((item, index) => (
            <motion.div
              key={`${item.date}-${item.title}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.25 }}
              transition={{ duration: 0.5, delay: index * 0.08 }}
              className="relative border-l border-academic-line pb-10 pl-8 last:pb-0"
            >
              <span className="absolute -left-[7px] top-2 h-3.5 w-3.5 rounded-full border-2 border-academic-blue bg-academic-bg" />
              <div className="card p-6">
                <p className="text-sm font-semibold text-academic-blue">{item.date}</p>
                <h3 className="mt-2 text-xl font-semibold text-academic-text">{item.title}</h3>
                <p className="mt-1 text-sm font-medium text-academic-muted">{item.organization}</p>
                <ul className="mt-5 space-y-3 text-academic-muted">
                  {item.points.map((point) => (
                    <li key={point} className="flex gap-3 leading-7">
                      <span className="mt-3 h-1.5 w-1.5 shrink-0 rounded-full bg-academic-blue" />
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Experience
